/* eslint-disable no-template-curly-in-string */
import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  calibrationCertificatesAreNotAvailable: {
    id: 'certificateIcon.calibrationCertificatesAreNotAvailable',
    defaultMessage: 'Calibration certificates are not available',
  },
  calibrationCertificates: {
    id: 'certificateIcon.calibrationCertificates',
    defaultMessage: 'Calibration certificates',
  },
})
